import TopNotchLocs from "../../images/TopNotchLocks.png";
import WorldShutters from "../../images/WorldShutters.png";
import Sarcina from "../../images/Sarcina.png";
import KingBlackVIP from "../../images/KingBlackVIP.png";

export const ProjectsList = [
    {
        id: 1,
        name: "Top Notch Locs",
        image: TopNotchLocs,
        link: "https://top-notch-locs.netlify.app/",
        category: "concepts"
    },
    {
        id: 2,
        name: "World Shutters",
        image: WorldShutters,
        link: "https://world-shutters-photography.netlify.app/",
        category: "concepts"
    },
    {
        id: 3,
        name: "Sarcina",
        image: Sarcina,
        link: "https://sarcina.ng",
        category: "comissions"
    },
    {
        id: 4,
        name: "King Black VIP",
        image: KingBlackVIP,
        link: "https://kingblackvip.com",
        category: "comissions"
    }
]
